import React from 'react';
import Layout from '../../../components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { Users, Settings, Shield, UserPlus, FileText } from 'lucide-react';
import { UserManagement } from '../components/UserManagement';
import { SystemSettings } from '../components/SystemSettings';
import { mockUsers } from '../data/mockUsers';
import { UserAccessIndex } from '../components/UserAccess/Index';
import { useUserPermissionsAfterLogin } from '../hooks/useUserPermissionsAfterLogin';


interface AdminPageProps {
  currentUser: any; // Replace with proper type
}


const AdminPage: React.FC = () => {
  const currentUser = mockUsers[0]; // Use the super admin as the current user
  const [activeTab, setActiveTab] = React.useState('users');

  const { hasPermission } = useUserPermissionsAfterLogin();
  const ADMIN_TABS_CONFIG = {
    users: {
      label: 'User Management',
      icon: Users,
      content: (props: any) => <UserManagement {...props} />,
      name: 'manage_users'
    },
    settings: {
      label: 'System Settings',
      icon: Settings,
      content: (props: any) => <SystemSettings {...props} />,
      name: 'manage_system'
    },
    userAccessSettings: {
      label: 'User Access Settings' ,
      icon: Settings,
      content: (props: any) => <UserAccessIndex {...props} />,
      name: 'manage_user_access'
    }
  } as const;
  
  return (
    <Layout>
      <div className="min-h-screen" style={{paddingLeft:10, paddingRight:10 }}>
      <div className="max-w-[2000px] mx-auto px-2">
          <div className="bg-white rounded-lg shadow-sm min-h-[calc(100vh-100px)]">
            <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
              <div className="sticky top-0 bg-white rounded-t-lg z-10 border-b border-gray-200 rounded-t-lg">
                <TabsList className="h-12 w-full justify-start gap-8 border-b border-gray-200 bg-transparent px-4 py-8">
                  {Object.entries(ADMIN_TABS_CONFIG).filter(([key, { name }]) => hasPermission(name)).map(([key, { label, icon: Icon }]) => (
                    <TabsTrigger
                      key={key}
                      value={key}
                       className="data-[state=active]:border-[#EB1C37] data-[state=active]:text-[#EB1C37] relative px-1 pb-3 pt-2 text-base font-medium text-gray-500 hover:text-gray-700 data-[state=active]:border-b-[0.5px]"
                    >
                      <div className="flex items-center gap-2">
                        <Icon className="h-4 w-4" />
                        {label}
                      </div>
                    </TabsTrigger>
                  ))}
                </TabsList>
              </div>

              {Object.entries(ADMIN_TABS_CONFIG).map(([key, { content: Content }]) => (
                <TabsContent key={key} value={key}>
                  <div className="flex flex-col h-full">
                    <div className="sticky top-[72px] bg-white z-10 px-4 py-4 border-b  rounded-b-lg">
                      <Content currentUser={currentUser} />
                    </div>
                  </div>
                </TabsContent>
              ))}
            </Tabs>
          </div>
        </div>
      </div>
    </Layout>
  );
}; 
export default AdminPage; 